/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ResolutionInputs */

const en_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native Resolution`)
};

const es_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolución nativa`)
};

const fr_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résolution native`)
};

const de_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native Auflösung`)
};

const ja_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネイティブ解像度`)
};

const zh_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原生分辨率`)
};

const ar_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدقة الأصلية`)
};

const id_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolusi Asli`)
};

const it_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risoluzione Nativa`)
};

const ru_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Собственное разрешение`)
};

const pt_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolução Nativa`)
};

const ko_field_resolution = /** @type {(inputs: Field_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기본 해상도`)
};

/**
* | output |
* | --- |
* | "Native Resolution" |
*
* @param {Field_ResolutionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_resolution = /** @type {((inputs?: Field_ResolutionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ResolutionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_resolution(inputs)
	if (locale === "es") return es_field_resolution(inputs)
	if (locale === "fr") return fr_field_resolution(inputs)
	if (locale === "de") return de_field_resolution(inputs)
	if (locale === "ja") return ja_field_resolution(inputs)
	if (locale === "zh") return zh_field_resolution(inputs)
	if (locale === "ar") return ar_field_resolution(inputs)
	if (locale === "id") return id_field_resolution(inputs)
	if (locale === "it") return it_field_resolution(inputs)
	if (locale === "ru") return ru_field_resolution(inputs)
	if (locale === "pt") return pt_field_resolution(inputs)
	return ko_field_resolution(inputs)
});